/**
 * @module hooks/useStationsWebService
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Use FDSNWS API for getting StationXML information and stored as a Stations array
 */

import { useState, useReducer, useEffect } from 'react';
import axios from 'axios';
import xml2js from 'xml2js';

import { Networks } from '../libs/networks';


/**
 * Reducer for URL fetching
 * @param {*} state 
 * @param {*} action 
 */
const stationsFetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isLoading: true,
        isError: false,
        networks: new Networks(),
      };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isError: false,
        networks: action.payload,
      };
    case 'FETCH_FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
        networks: new Networks(),
      }
    default:
      throw new Error();
  }
};


const useNetworksWebService = (initialUrl, initialNetworks = []) => {

  const [ url, setUrl ] = useState(initialUrl);
  const [ state, dispatch ] = useReducer(stationsFetchReducer, {
    isLoading: false,
    isError: false,
    networks: new Networks(...initialNetworks),
  });

  // Fetch the new information only when "url" has been updated
  useEffect(() => {
    let didCancel = false;

    const fetchData = async() => {
      try {
        // only fetch if the url is set
        if (url) {
          // indicate to we are starting the async fetch
          dispatch({type: 'FETCH_INIT'});
          // fetch the url and wait for the result
          const result = await axios.get(url);
          if (!didCancel) {
            xml2js.parseString(result.data, (err, result) => {
              if (err) {
                dispatch({type: 'FETCH_FAILURE'});
              } else {
                dispatch({type: 'FETCH_SUCCESS', payload: new Networks(...result.FDSNStationXML.Network)});
              }
            });
          }
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({type: 'FETCH_FAILURE'});
        }
      }
    };

    // fetch the data
    fetchData();

    // cleaning up the request
    return () => {
      didCancel = true;
    }

  }, [url]);

  return { ...state, url, setUrl };
};

export default useNetworksWebService;